import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function ModalFooter(props) {
  const {
    onCancel,
    onSave,
    cancelText,
    saveText,
    saveIsLoader,
    disabled,
    disabledSave,
  } = props;

  const saveClasses = cx('btn', 'btn-dynamic', {
    'm-loader': saveIsLoader,
    'm-loader--right': saveIsLoader,
    'm-loader--light': saveIsLoader,
  });

  return (
    <div className="modal-footer">
      {onCancel && cancelText && (
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onCancel}
          disabled={disabled}
        >
          {cancelText}
        </button>
      )}
      {saveText && (
        <button
          type="submit"
          className={saveClasses}
          onClick={onSave}
          disabled={disabled || disabledSave}
        >
          {saveText}
        </button>
      )}
    </div>
  );
}

ModalFooter.propTypes = {
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  cancelText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  saveText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  saveIsLoader: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledSave: PropTypes.bool,
};

ModalFooter.defaultProps = {
  onCancel: () => {},
  onSave: () => {},
  saveText: null,
  cancelText: '',
  saveIsLoader: false,
  disabled: false,
  disabledSave: false,
};
